module.exports = __webpack_public_path__ + "img/body-2-lg.76d53c72.png";